import imageSlider1 from '../../assets/imageSlider1.jpg';
import imageSlider2 from '../../assets/imageSlider2.jpg';
import imageSlider3 from '../../assets/imageSlider3.jpg';
import imageSlider4 from '../../assets/imageSlider4.jpg';
import imageSlider5 from '../../assets/imageSlider5.jpg';
import imageSlider6 from '../../assets/imageSlider6.jpg';
import imageSlider7 from '../../assets/imageSlider7.jpg';
import imageSlider8 from '../../assets/imageSlider8.jpg';
import imageSlider9 from '../../assets/imageSlider9.jpg';
import imageSlider10 from '../../assets/imageSlider10.jpg';
import imageSlider11 from '../../assets/imageSlider11.jpg';
import imageSlider12 from '../../assets/imageSlider12.jpg';

export default [{image:imageSlider1}, 
                {image:imageSlider2}, 
                {image:imageSlider3}, 
                {image:imageSlider4}, 
                {image:imageSlider5}, 
                {image:imageSlider6}, 
                {image:imageSlider7}, 
                {image:imageSlider8},
                {image:imageSlider9}, 
                {image:imageSlider10},
                {image:imageSlider11}, 
                {image:imageSlider12}]